import packageJson from '../../../package.json';

const baseUrl = `${window.location.origin}`;

window.CKEDITOR_BASEPATH = `/static/V${packageJson.version}/ckeditor/`;
window.CKFINDER_BASEPATH = `/static/V${packageJson.version}/ckfinder/`;

export default {
  api: {
    baseUrl,
    authorization: '',
    enableBFF: true,
  },
  baseName: '',
  assetUrl: '{{SANDCASTLE_CDN}}',
  assetPath: `/static/V${packageJson.version}/assets/images/`,
  assetJsPath: `/static/V${packageJson.version}/assets/js/`,
  slideTemplatePath: '/content/media/slideTemplate/images/',
  learningModuleTemplatePath: `/static/V${packageJson.version}/assets/learning_module_template/`,
  ckFinderConnectorPath: `${baseUrl}/ckfc/ckfinder/connector`,
  serviceName: 'ELA - Staging - SPA',
  serverUrl: 'https://s-pub-apm-server.elmotalent.com.au',
  isAPMEnabled: true,
  getManifestURL: `${baseUrl}/get-manifest`,
  getTokenURL: `${baseUrl}/oauth2-client/auth/check-token`,
  getNavigationURL: `${baseUrl}/bff/navigation`,
  getUserInfoURL: `${baseUrl}/bff/user`,
  launchDarklyClientSideId: process.env.REACT_APP_LAUNCHDARKLY_CLIENT_ID,
  OldCBURL: 'https://lcms.dev.elmodev.com',
  OldCBTOKEN: 'd27cfd44d40d37576bbdfefa8ef30556',
  NextMenuUrl: 'https://hcm.cdn.elmodev.com/menu-next/main.js',
};
